var M = /* @__PURE__ */ ((m) => (m.NORMAL = "normal", m.MINI = "mini", m.JUMBO = "jumbo", m.MAXI = "maxi", m))(M || {}), o = /* @__PURE__ */ ((m) => (m.NORMAL = "normal", m.MINI = "mini", m.JUMBO = "jumbo", m))(o || {});
export {
  o as R,
  M as S
};
